<template>
	<div>
		<button class="better-mobile-btn" v-on:click="startScanning" :class="rfid ? 'grey-background' : ''">
			<HandIcon/>
			{{ rfid ? "Re-Scan Wristband" : "Scan Wristband" }}
		</button>

		<div v-if="scanningRfid" class="fullscreen-overlay">
			<h2 class="overlay-header">{{ user_name }}</h2>

			<div class="overlay-body">
				<h5 class="p-05">{{ credential_title }}</h5>

				<div>
					<div v-if="awaitingScan" class="p-05">
						<LoadingDots/>
						<p>Press the RFID against the reader</p>
					</div>

					<div class="p-05">
						<button
							:disabled="awaitingScan"
							class="better-mobile-btn"
							v-on:click="complete">
							{{ awaitingScan ? "Scanning RFID..." : "Placed Wristband on Patron" }}
						</button>
					</div>

					<div v-if="isTesting && awaitingScan" class="p-05">
						<button
							class="better-mobile-btn"
							v-on:click="addFakeRFID">
							Add Fake TEST RFID
						</button>
					</div>
				</div>

				<div class="p-1">
					<button class="better-mobile-btn red" v-on:click="back">Back</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/*
	RFID is emitted as a Low to High 7 byte Hex string (14 chars) with the colons stripped.
 */

import HandIcon from "./icons_svg/HandIcon.vue";
import LoadingDots from "./icons_svg/LoadingDots.vue";

const abortController = new AbortController();

export default {
	name: 'ScanRFIDButton',
	components: {
		HandIcon,
		LoadingDots
	},
	props: {
		user_name: {
			type: String,
			required: true
		},
		credential_title: {
			type: String,
			required: true
		},
		initial_value: {
			type: String,
			default: ""
		},
	},
	data() {
		return {
			shouldEmit: false,
			rfid: this.initial_value,
			scanningRfid: false,
			awaitingScan: true,
		}
	},
	watch: {
		isActive: function (val) {
			this.shouldEmit = val;
			if (!val) {
				this.resetState();
				abortController.abort();
			}
		}
	},
	computed: {
		isStagingSite() {
			return process.env.VUE_APP_API_SERVER.indexOf("staging") >= 0
		},
		isTesting() {
			return !this.doesDeviceHaveNFC() || this.isStagingSite
		},
	},
	methods: {
		// Called when an RFID is read successfully
		onRfidRead(rfid) {
			// Make sure we're active due to multiple scanRFID elements & webnfc
			if (!this.shouldEmit) {
				return;
			}
			// Strip colons
			rfid = rfid.replaceAll(':', '');
			this.rfid = rfid;
			this.shouldEmit = false;
			this.awaitingScan = false;
		},
		doesDeviceHaveNFC() {
			return "NDEFReader" in window
		},
		async startScanning() {
			this.scanningRfid = true;
			this.awaitingScan = true;
			this.shouldEmit = true;

			try {
				// Make sure browser (only chrome on devices so far) supports NFC
				// If not, fake a barcode for testing
				if (!this.doesDeviceHaveNFC()) {
					return
				}

				const ndef = new NDEFReader();
				// Add failing listeners
				ndef.addEventListener("readingerror", () => {
					this.resetState();
					alert("Cannot read data from the RFID. Try again or return it to your Gate Supervisor.");
				});

				// Scanned logic happens here
				ndef.addEventListener("reading", ({message, serialNumber}) => {
					this.onRfidRead(serialNumber);
				});
				await ndef.scan();
			} catch (error) {
				this.resetState();
				alert("error" + error);
			}

			//TODO what is isActive for?
			// // This is used to set the parent's isActive to true
			// this.$emit('onClicked', this.scanningFor);
			//
		},
		addFakeRFID() {
			this.onRfidRead('rfid_test_' + Date.now());
		},
		complete() {
			this.$emit('onScannedRfid', this.rfid);
			this.resetState();
		},
		resetState() {
			this.rfid = '';
			this.scanningRfid = false
			this.awaitingScan = true
		},
		back() {
			this.resetState()
		},
	},
}
</script>

<style scoped>
.scan-rfid .loading-message {
	animation: pulse 1.65s infinite linear;
}

.grey-background {
	background: #666 !important;
}
</style>